import React from 'react';
import { translate } from 'react-polyglot';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/react";
function NoAnalytics({
  t
}) {
  function handleHideMessage() {
    // dispatch(hideNoAnalyticsMessage());
  }
  return ___EmotionJSX("div", null, ___EmotionJSX("p", null, t('dashboard.siteAnalytics.noAnalytics')));
}
NoAnalytics.propTypes = {
  t: PropTypes.func.isRequired
};
export default translate()(NoAnalytics);